export default {
  bind(el) {
    const img = new Image();
    img.onerror = function() {
      el.style.display = 'none';

      const altSpan = document.createElement('span');
      altSpan.innerHTML = el.alt;
      el.parentNode.insertBefore(altSpan, el);
    };

    img.src = el.src;
  }
};
